__turbopack_context__.v({
  "categoriesContainer": "styles-module-scss-module__UvrR4a__categoriesContainer",
  "categoriesSelectContainer": "styles-module-scss-module__UvrR4a__categoriesSelectContainer",
  "expandCollapseBtn": "styles-module-scss-module__UvrR4a__expandCollapseBtn",
  "searchFormField": "styles-module-scss-module__UvrR4a__searchFormField",
  "searchInputField": "styles-module-scss-module__UvrR4a__searchInputField",
  "statsContainer": "styles-module-scss-module__UvrR4a__statsContainer",
});
